

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _index = require('components/xo-models/src/checkout/index');

var _index2 = require('components/xo-models/src/auth/index');

require('components/xo-address-components/src/address-display/directive');

require('components/xo-ui-components/src/accessibility/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend({
    tag: 'xo-review-address',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        makeAddrPreferred: {
            type: 'var',
            required: false
        },
        countryCode: {
            type: 'str',
            required: false
        },
        storePickUpSelected: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                auth: _index2.$AuthModel.instance().retrieve()
            };
        }
    },

    actions: {
        gotoShipping: function gotoShipping() {
            if (this.models.checkoutAppData.flags.allow_change_shipping) {
                _uiRouter.$state.go('checkout.review.sidebar.shipping');
            } else {
                this.cannotChangeShippingInfoMessages = true;
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var updateMakePreferredFlag = function updateMakePreferredFlag(flag) {
                if (_this.makeAddrPreferred) {
                    // Update the makeAddrPreferred.shown flag, for the caller to know about it.
                    _this.makeAddrPreferred.shown = flag;
                }
                return flag;
            };

            /**
             * Decision on whether to show Make Preferred Checkbox
             * @returns {boolean}
             */
            this.isMakePreferred = function () {
                if (_this.models.auth.remembered) {
                    return updateMakePreferredFlag(false);
                }

                if (_this.isPreferredShippingEnabled && !_this.models.checkoutSession.get('shipping.preferred_address') && !_this.models.checkoutSession.get('shipping.s2s_address')) {
                    return updateMakePreferredFlag(true);
                }

                return updateMakePreferredFlag(false);
            };
        },
        populate: function populate() {

            // countryCode is not available, hence we use the shipping.county to retrieve the feature flag.
            var shipping = this.models.checkoutSession && this.models.checkoutSession.shipping || {};

            this.isPreferredShippingEnabled = (0, _squid.$feature)('preferredShipping', false, shipping.country);
        }
    }
});


_uiRouter.$state;

_squid.$Component;

_squid.$feature;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$AuthModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/review-address/directive.js
// module id = ./components/xo-member-components/src/review-address/directive.js
// module chunks = 1